export default "__VITE_ASSET__YhpPstuE__"